import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Resets scroll to the top whenever the route changes.
 * Should be rendered inside the Router but outside Routes.
 */
export function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return null;
}